import {
	reAddressTypeConstants
}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : {},
	pagedAudit : null,
	countAudit : null,
	list       : [],
	changed    : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reAddressTypeConstants.GetPaged.REQUEST:
		case reAddressTypeConstants.GetPagedAudit.REQUEST:
		case reAddressTypeConstants.GetPagedAll.REQUEST:
		case reAddressTypeConstants.GetList.REQUEST:
		case reAddressTypeConstants.Create.REQUEST:
		case reAddressTypeConstants.Delete.REQUEST:
		case reAddressTypeConstants.Restore.REQUEST:
		case reAddressTypeConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reAddressTypeConstants.GetPaged.FAILURE:
		case reAddressTypeConstants.GetPagedAudit.FAILURE:
		case reAddressTypeConstants.GetPagedAll.FAILURE:
		case reAddressTypeConstants.GetList.FAILURE:
		case reAddressTypeConstants.Create.FAILURE:
		case reAddressTypeConstants.Delete.FAILURE:
		case reAddressTypeConstants.Restore.FAILURE:
		case reAddressTypeConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reAddressTypeConstants.GetPaged.SUCCESS:
		case reAddressTypeConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reAddressTypeConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				pagedAudit : action.payload.result.items,
				countAudit : action.payload.result.count,
				isSending  : false
			}
		case reAddressTypeConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reAddressTypeConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reAddressTypeConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reAddressTypeConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reAddressTypeConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reAddressTypeConstants.CLEAR:
			return {
				...state,
				changed   : null,
				isSending : false,
				paged     : {},
				list      : []
			}
		default:
			return state
	}
}